export class BfxBlotterDeleteFilterActionEvent {
  constructor(callback: any) {
    this._callback = callback;
  }
  public _callback: any;
}
